export const UpdateSpaceGroupPermissionRepository = Symbol('UpdateSpaceGroupPermissionRepository');
export const QuerySpaceGroupPermissionRepository = Symbol('QuerySpaceGroupPermissionRepository');
